import individualWorkSupportUtil from '../../../../share/util/individualWorkSupportUtil';
import session from '../../../../share/session';

/**
 * Dispose処理
 * @param {object} self this インスタンス
 * @param {string} nextPhase 遷移先のphase
 */
export async function dispose(self, nextPhase) {
  try {
    self.isLoading = true;
    const token = session.getToken();
    await individualWorkSupportUtil.pollingWspApi(
      self,
      self.netAppId,
      self.systemId,
      self.workSupportId,
      {
        id_token: token.id_token,
        type: 'dispose'
      },
      // エラー発生のコールバック
      async (errorType) => { errorType; await self.showUnexpectedError(); },
      // POST API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバック
      async (result) => { await self.validateErrorResult(result); },
      // GET API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバック
      async (result) => { await self.validateErrorResult(result); },
    );

    // レスポンスは見ない
    // nextPhase がある場合のみ遷移する
    if (nextPhase) {
      self.phase = nextPhase;
    }
  } finally {
    self.isLoading = false;
  }
}